exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Define the proper variables ans redefine Boostrap ones */\n.label-part-param {\n  border: #ea705a 1px solid; }\n  .label-part-param .card {\n    padding: 10px; }\n\n.part-img {\n  max-height: 200px; }\n", ""]);

